import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7cfc8884")

_pushScopeId("data-v-7cfc8884")
const _hoisted_1 = { class: "LTLTemplate" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_order_progress = _resolveComponent("order-progress")!
  const _component_new_ltl_additional_services = _resolveComponent("new-ltl-additional-services")!
  const _component_senders_panel = _resolveComponent("senders-panel")!
  const _component_send_date_time_period = _resolveComponent("send-date-time-period")!
  const _component_ltl_receivers_panel = _resolveComponent("ltl-receivers-panel")!
  const _component_ltl_receiver = _resolveComponent("ltl-receiver")!
  const _component_ltl_cargo_payment = _resolveComponent("ltl-cargo-payment")!
  const _component_ltl_invoices = _resolveComponent("ltl-invoices")!
  const _component_success_order = _resolveComponent("success-order")!
  const _component_s_modal = _resolveComponent("s-modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (Boolean(_ctx.LTLOrderState.sender))
      ? (_openBlock(), _createBlock(_component_order_progress, {
          key: 0,
          isFTL: _ctx.isFTL,
          isLTL: _ctx.isLTL,
          sender: _ctx.LTLOrderState.sender,
          "send-date": _ctx.LTLOrderState.send_date,
          "send-period": _ctx.LTLOrderState.send_period,
          blocked: _ctx.LTLOrderState.isCreated,
          "additional-services": _ctx.LTLOrderState.additional_services,
          "additional-services-billing": _ctx.state.additional_services,
          "is-additional-services-setted": _ctx.LTLOrderState.isAdditionalServicesSetted,
          onResetSender: _ctx.resetSender,
          onResetCalendar: _ctx.resetDatePayload,
          onOpenAdditionalServices: _ctx.openAdditionalServices,
          onResetAdditionalServices: _ctx.resetAdditionalServices
        }, null, 8, ["isFTL", "isLTL", "sender", "send-date", "send-period", "blocked", "additional-services", "additional-services-billing", "is-additional-services-setted", "onResetSender", "onResetCalendar", "onOpenAdditionalServices", "onResetAdditionalServices"]))
      : _createCommentVNode("", true),
    (_ctx.LTLOrderState.isAdditionalServicesOpened)
      ? (_openBlock(), _createBlock(_component_new_ltl_additional_services, {
          key: 1,
          "initial-values": _ctx.LTLOrderState.additional_services,
          "additional-services": _ctx.state.additional_services,
          onContinue: _ctx.setAdditionalServices,
          onClose: _ctx.closeAdditionalServices
        }, null, 8, ["initial-values", "additional-services", "onContinue", "onClose"]))
      : _createCommentVNode("", true),
    (!Boolean(_ctx.LTLOrderState.sender))
      ? (_openBlock(), _createBlock(_component_senders_panel, {
          key: 2,
          isFTL: _ctx.isFTL,
          isLTL: _ctx.isLTL,
          loading: _ctx.LTLOrderState.senders.request.is_loading,
          failed: _ctx.LTLOrderState.senders.request.is_failed,
          senders: _ctx.LTLOrderState.senders.data,
          current_page: _ctx.LTLOrderState.senders.pagination.current_page,
          total_pages: _ctx.LTLOrderState.senders.pagination.total_pages,
          "is-search": _ctx.LTLOrderState.isSenderSearch,
          onLoadmore: _ctx.loadMoreSendersHandler,
          onSelect: _ctx.onSelectSender,
          onSearch: _ctx.searchSendersHandler,
          onDelete: _ctx.removeSender
        }, null, 8, ["isFTL", "isLTL", "loading", "failed", "senders", "current_page", "total_pages", "is-search", "onLoadmore", "onSelect", "onSearch", "onDelete"]))
      : _createCommentVNode("", true),
    (!Boolean(_ctx.LTLOrderState.send_date))
      ? (_openBlock(), _createBlock(_component_send_date_time_period, {
          key: 3,
          isFTL: _ctx.isFTL,
          isLTL: _ctx.isLTL,
          opened: Boolean(_ctx.LTLOrderState.sender),
          onConfirm: _ctx.setDatePayload
        }, null, 8, ["isFTL", "isLTL", "opened", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.LTLOrderState.is_select_receiver)
      ? (_openBlock(), _createBlock(_component_ltl_receivers_panel, {
          key: 4,
          opened: Boolean(_ctx.LTLOrderState.sender) && Boolean(_ctx.LTLOrderState.send_date),
          loading: _ctx.LTLOrderState.receivers.request.is_loading,
          "excel-loading": _ctx.LTLOrderState.isCreateLoading,
          failed: _ctx.LTLOrderState.receivers.request.is_failed,
          receivers: _ctx.LTLOrderState.receivers.data,
          current_page: _ctx.LTLOrderState.receivers.pagination.current_page,
          total_pages: _ctx.LTLOrderState.receivers.pagination.total_pages,
          "is-search": _ctx.LTLOrderState.isReceiversSearch,
          "selected-receivers-ids": _ctx.LTLOrderState.selected_receivers_ids,
          "sender-city-id": _ctx.senderCityId,
          blocked: _ctx.LTLOrderState.isCreated,
          isLTL: "",
          onMounted: _ctx.loadReceiversHandler,
          onLoadmore: _ctx.loadMoreReceiversHandler,
          onSelect: _ctx.selectReceiver,
          onSearch: _ctx.searchReceiversHandler,
          onExcel: _ctx.createByExcelHandler,
          onDelete: _ctx.removeReceiver
        }, null, 8, ["opened", "loading", "excel-loading", "failed", "receivers", "current_page", "total_pages", "is-search", "selected-receivers-ids", "sender-city-id", "blocked", "onMounted", "onLoadmore", "onSelect", "onSearch", "onExcel", "onDelete"]))
      : _createCommentVNode("", true),
    (Boolean(_ctx.LTLOrderState.receiver) && _ctx.LTLOrderState.invoices.length === 0)
      ? (_openBlock(), _createBlock(_component_ltl_receiver, {
          key: 5,
          receiver: _ctx.LTLOrderState.receiver,
          onReset: _ctx.resetLTLReceiver,
          blocked: !_ctx.LTLOrderState.is_add_invoice
        }, null, 8, ["receiver", "onReset", "blocked"]))
      : _createCommentVNode("", true),
    (_ctx.LTLOrderState.is_add_invoice || _ctx.LTLOrderState.is_update_invoice)
      ? (_openBlock(), _createBlock(_component_ltl_cargo_payment, {
          key: 6,
          "additional-services": _ctx.state.additional_services,
          "sender-title": _ctx.state.company_name,
          "company-id": _ctx.state.company_id,
          opened: Boolean(_ctx.LTLOrderState.receiver),
          "is-only-auto": _ctx.isOnlyAutoTransportation,
          "is-pvz": 
                Boolean(_ctx.LTLOrderState.receiver) &&
                Boolean(_ctx.LTLOrderState.receiver.distribution_center_id)
            ,
          "is-update": _ctx.LTLOrderState.is_update_invoice,
          "updating-invoice": _ctx.LTLOrderState.updating_invoice,
          "receiver-city-type": _ctx.LTLOrderState.receiver ? _ctx.LTLOrderState.receiver.city_type : null,
          "is-cash-enabled-by-setting": _ctx.isCashEnabled,
          "is-kaspi-enabled-by-setting": _ctx.isKaspiEnabled,
          "is-commercial-return-enabled-by-setting": _ctx.isCommercialReturnEnabled,
          onAddInvoice: _ctx.addLTLInvoice,
          onUpdateInvoice: _ctx.updateLTLInvoice
        }, null, 8, ["additional-services", "sender-title", "company-id", "opened", "is-only-auto", "is-pvz", "is-update", "updating-invoice", "receiver-city-type", "is-cash-enabled-by-setting", "is-kaspi-enabled-by-setting", "is-commercial-return-enabled-by-setting", "onAddInvoice", "onUpdateInvoice"]))
      : _createCommentVNode("", true),
    (_ctx.LTLOrderState.invoices.length > 0)
      ? (_openBlock(), _createBlock(_component_ltl_invoices, {
          key: 7,
          isLTL: "",
          invoices: _ctx.LTLOrderState.invoices,
          loading: _ctx.LTLOrderState.isCreateLoading,
          blocked: _ctx.LTLOrderState.isCreated,
          "additional-services": _ctx.state.additional_services,
          "is-bosch": _ctx.isBosch,
          onAddInvoiceAdditionalServices: _ctx.setAdditionalServicesForLTLInvoice,
          onResetInvoiceAdditionalServices: _ctx.resetAdditionalServicesForLTLInvoice,
          onDelete: _ctx.removeLTLInvoice,
          onStartAdd: _ctx.startAddLTLInvoice,
          onCreate: _ctx.createHandler,
          onReset: _ctx.resetHandler,
          onUpdate: _ctx.startUpdateLTLInvoice
        }, null, 8, ["invoices", "loading", "blocked", "additional-services", "is-bosch", "onAddInvoiceAdditionalServices", "onResetInvoiceAdditionalServices", "onDelete", "onStartAdd", "onCreate", "onReset", "onUpdate"]))
      : _createCommentVNode("", true),
    (_ctx.isSuccessModalOpened)
      ? (_openBlock(), _createBlock(_component_s_modal, {
          key: 8,
          class: "ltl",
          onClose: _ctx.closeSuccessModal
        }, {
          body: _withId(() => [
            _createVNode(_component_success_order, { onReset: _ctx.resetHandler }, null, 8, ["onReset"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
})